import { render, staticRenderFns } from "./PopupClientReferral.vue?vue&type=template&id=30f0bbbe"
import script from "./PopupClientReferral.vue?vue&type=script&lang=js"
export * from "./PopupClientReferral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30f0bbbe')) {
      api.createRecord('30f0bbbe', component.options)
    } else {
      api.reload('30f0bbbe', component.options)
    }
    module.hot.accept("./PopupClientReferral.vue?vue&type=template&id=30f0bbbe", function () {
      api.rerender('30f0bbbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Account/PopUps/PopupClientReferral.vue"
export default component.exports